import React from 'react';
import { Box, Container, Typography, Grid, IconButton, Link } from '@mui/material';
import { Phone, Email, LocationOn, Instagram, Facebook, WhatsApp } from '@mui/icons-material';

const Footer: React.FC = () => {
  return (
    <Box sx={{ bgcolor: '#9c4f96', color: 'white', py: 6 }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              Thayne Silva Prado
            </Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>
              Cirurgiã Dentista - CRO/PR.  38004
            </Typography>
            <Typography variant="body2">
              Cuidando do seu sorriso com dedicação e profissionalismo.
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              Contato
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', mb:  1 }}>
              <Phone sx={{ mr: 1, fontSize: 20 }} />
              <Typography variant="body2">(42) 99872-0555</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <Email sx={{ mr:  1, fontSize: 20 }} />
              <Typography variant="body2">contato@tsodonto.com.br</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems:  'center' }}>
              <LocationOn sx={{ mr: 1, fontSize: 20 }} />
              <Typography variant="body2">Rua Quinze de Novembro, 512 - 2º andar - sala 23 - Centro, Boulevard Center</Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              Redes Sociais
            </Typography>
            <Box>
              <IconButton sx={{ color: 'white' }} href="https://www.instagram.com/dentista_thaynesilvaprado?igsh=N29ndDkxamw1OXRz" target="_blank">
                <Instagram />
              </IconButton>
              <IconButton sx={{ color: 'white' }} href="https://wa.me/5542998720555" target="_blank">
                <WhatsApp />
              </IconButton>
            </Box>
          </Grid>
        </Grid>
        
        <Box sx={{ mt: 4, pt: 4, borderTop: '1px solid rgba(255,255,255,0.2)' }}>
          <Grid container spacing={2} justifyContent="center" alignItems="center">
            <Grid item xs={12} md={6}>
              <Typography variant="body2" align="center">
                © {new Date().getFullYear()} Thayne Silva Prado - Todos os direitos reservados
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box sx={{ display: 'flex', gap: 3, justifyContent: 'center' }}>
                <Link 
                  href="/privacidade" 
                  target="_blank"
                  sx={{ 
                    color: 'white', 
                    textDecoration: 'none',
                    '&:hover': { textDecoration: 'underline' }
                  }}
                >
                  <Typography variant="body2">Política de Privacidade</Typography>
                </Link>
                <Link 
                  href="/termos" 
                  target="_blank"
                  sx={{ 
                    color: 'white', 
                    textDecoration: 'none',
                    '&:hover': { textDecoration: 'underline' }
                  }}
                >
                  <Typography variant="body2">Termos de Uso</Typography>
                </Link>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;